<section class="license-page">
  <h1>Lizenzen</h1>
  <p>Diese Seite wird später mit Lizenzinformationen ergänzt.</p>
  <button mat-stroked-button color="primary" routerLink="/vorauswahl">Zur Terminbuchung</button>
</section>
